module.exports = __webpack_public_path__ + "img/logo.c3b9785b.png";